import { useContext } from 'react';
import { CheckoutFormContext } from '../../context/CheckoutFormContext/context';

function useCheckoutFormState() {
  const { state, dispatch } = useContext(CheckoutFormContext);

  return { state, dispatch };
}

export default useCheckoutFormState;
